module.exports = __webpack_public_path__ + "static/media/icons8-angularjs.64a3fd75.svg";